// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_en-0";